export default {"src":"/_next/static/media/app.7ff9789d.gif","height":1080,"width":1080,"blurWidth":0,"blurHeight":0};